module.exports = __webpack_public_path__ + "img/jbo_icon.1a0484bf.svg";